var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useEffect, useState } from 'react';
import { FiArrowUp, FiArrowDown } from 'react-icons/fi';
import { Box, Icon, PopoverAnchor } from 'shared/components/ui';
import { Text, Flex } from 'shared/components/ui';
import { TrackedClick } from 'src/shared/features/analytics';
import { HeaderInfoPopover } from '../HeaderInfoPopover';
export var SortableTableHeader = function (_a) {
    var title = _a.title, isSorted = _a.isSorted, _b = _a.isSortedDesc, isSortedDesc = _b === void 0 ? false : _b, icon = _a.icon, popoverProps = _a.popoverProps;
    var _c = useState('white.50'), bgColor = _c[0], setBgColor = _c[1];
    useEffect(function () {
        if (isSorted) {
            setBgColor('green.100');
        }
        else {
            setBgColor('white.50');
        }
    }, [isSorted]);
    var AnchorComponent = popoverProps ? PopoverAnchor : Fragment;
    var PopoverComponent = popoverProps
        ? (function (_a) {
            var children = _a.children;
            return (_jsx(HeaderInfoPopover, __assign({}, popoverProps, { children: children })));
        })
        : Fragment;
    var trackingEventProps = {
        spring_doc_id: 'compass026',
    };
    return (_jsx(PopoverComponent, { children: _jsx(Box, __assign({ height: 12, w: "100%", bg: bgColor, mb: -1 }, { children: _jsx(AnchorComponent, { children: _jsxs(Flex, __assign({ h: "full", w: "fit-content", ml: 2, alignItems: "center" }, { children: [icon && _jsx(Icon, { as: icon, boxSize: 3.5, mr: 1 }), _jsx(TrackedClick, __assign({ eventName: title, eventProperties: trackingEventProps }, { children: _jsx(Text, __assign({ textTransform: 'none', size: "body2", "data-testid": "table-header-".concat(title) }, { children: title })) })), isSorted ? (_jsx(TrackedClick, __assign({ eventName: title, eventProperties: trackingEventProps }, { children: _jsx(Icon, { as: isSortedDesc ? FiArrowDown : FiArrowUp, color: "green.500", boxSize: 4, ml: 2 }) }))) : null] })) }) })) }));
};
